import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

const VideoComponent = (props) => {
  return (
    <Fragment>
      <div id="texto-1" className="quienes-somos">
        {props.cambiarIdioma ? "¿quiénes somos?" : "WHO ARE WE?"}
      </div>
      <div id="texto-2" className="contenedor-boton-ver-video">
        <div className="contenedor-boton">
          <div id="content-ver-video">
            <Button variant="outline-dark" onClick={() => props.evento(true)}>
              {props.cambiarIdioma ? "ver video" : "watch video"} &nbsp;&nbsp;{" "}
              <img src="/assets/fuentes/iconos/DerechaPequeño.svg" alt="" />
            </Button>
          </div>
        </div>
      </div>
      <video
        onClick={() => props.evento(false)}
        id="fondo-video"
        src="/assets/nosotros/JACK.mp4"
        autoPlay
        loop
      >
        Vídeo no es soportado...
      </video>
    </Fragment>
  );
};

VideoComponent.propTypes = {
  evento: PropTypes.func,
};

export default VideoComponent;
